<template>
  <div class="pa-4">
    <!-- PC TOOLBAR -->
    <div v-if="!$vuetify.breakpoint.xs" class="pl-4 pr-4 pt-4">

      <v-breadcrumbs class="pl-0 textSecondary--text">
        <v-breadcrumbs-item to="/dashboard/">
          Home
        </v-breadcrumbs-item>
        <span class="pl-2 pr-2">/</span>
        <v-breadcrumbs-item to="/deliveries">
            Deliveries
          </v-breadcrumbs-item>
          <span class="pl-2 pr-2">/</span>
          <v-breadcrumbs-item disabled>
            {{ id }}
          </v-breadcrumbs-item>
      </v-breadcrumbs>

      <v-row class="mb-2 align-center">
        <div class="title">
          Delivery {{ id }}
          <v-chip small color="blue" text-color="white" class="caption">In process</v-chip>
        </div>
        <v-spacer></v-spacer>
        <v-btn
        small
        rounded
        outlined
        :to="{ path: `/print/delivery/${id}` }"
        target="_blank"
        class="ml-2"
        >
          <v-icon>mdi-file-pdf-box</v-icon> Print
        </v-btn>
      </v-row>

    </div>
    <!-- !PC TOOLBAR -->

    <!-- MAIN -->
    <v-card>

      <v-row class="align-center pl-4 pr-2 pt-2 pb-2">

        <v-btn
        text
        outlined
        class="mr-2"
        @click="addItem">
          <v-icon>add</v-icon>
          <div class="ml-1">
            Add item
          </div>
        </v-btn>

        <v-spacer></v-spacer>

        <t-item-diff :item1="lastSave" :item2="merged">
          <v-layout 
          slot="item1Header"
          align-center class="subheading font-weight-bold pl-2 crx-toolbar">
            Last save
          </v-layout>
          <v-layout 
          slot="item2Header"
          align-center class="subheading font-weight-bold pl-2 crx-toolbar">
            LIVE
          </v-layout>
        </t-item-diff>
        

        <v-slide-x-transition
        mode="out-in">
          <v-btn
          v-if="isDirty"
          text
          outlined
          key="save2"
          width="8em"
          :loading="saving"

          @click="save">
            <v-icon color="color1">mdi-cloud-upload-outline</v-icon>
            <div class="ml-1">
              Save
            </div>
          </v-btn>

          <v-btn
          v-else
          key="save1"
          text
          width="8em"
          class="font-weight-regular"
          disabled>
            <v-icon small>mdi-shield-check-outline</v-icon>
            Saved
          </v-btn>
          
          
        </v-slide-x-transition>

        <v-btn
        :disabled="items.length === 0"
        @click="completeDeliveryClicked"
        color="color1"
        text
        :loading="completing"
        >
          Complete delivery
          <v-icon small class="ml-1">arrow_forward</v-icon>
        </v-btn>

        <div>
          <transition
          name="fade-transition"
          mode="out-in">
            <v-layout v-if="isLoading" key="L1" class="mr-2" align-baseline>
              <span class="grey--text caption">LOADING...</span>&nbsp;
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-layout>
            <div v-else key="L2"></div>
          </transition>
        </div>

      </v-row>

      <v-layout class="align-center pl-4">

        <transition
        name="slide-x-reverse-transition"
        mode="out-in">

          <!-- ITEMS -->
          <div 
          v-if="selectedCount === 0"
          key="1"
          class="c-flex-r align-center subheading">

            <!-- select menu -->
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>mdi-check-box-multiple-outline</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                @click="selectPage">
                  <v-list-item-title>Select page</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <div class="pa-4 label">
              {{ searchMatches.length }} items
            </div>

          </div>

          <!-- selected count -->
          <div v-if="selectedCount > 0"
          key="2"
          class="c-flex-r align-center subheading">
            <v-btn
            icon
            color="color1"
            class=""
            @click="selected = {}">
              <v-icon>close</v-icon>
            </v-btn>
            <div class="text-sans font-weight-bold">
              <span>&nbsp;{{ selectedCount }}</span>
              selected 
            </div>
            <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
            <span class="ml-2">|</span>
            <v-btn 
            icon
            @click="onDelete">
              <v-icon>delete_outline</v-icon>
            </v-btn>
            <!-- select menu -->
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>mdi-check-box-multiple-outline</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                @click="selectPage">
                  <v-list-item-title>Select page</v-list-item-title>
                </v-list-item>
                <v-list-item
                @click="selectNone">
                  <v-list-item-title>Select none</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

        </transition>

        <v-spacer></v-spacer>

        <div class="mr-4">

          <v-tooltip top open-delay="300">
            <template v-slot:activator="{ on }">
              <v-btn
              v-on="on"
              icon
              small
              color="color1"
              :disabled="page <= 0"
              @click="goToPreviousPage()"
              class=""
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </template>
            <span>Previous page</span>
          </v-tooltip>

          <template v-if="paginatedArray.length > 0">
            <span class="font-weight-bold">
              {{ page + 1 }}
            </span>
          </template>
          <template v-else>
            1
          </template>

          <v-tooltip top open-delay="300">
            <template v-slot:activator="{ on }">
              <v-btn
              v-on="on"
              icon
              small
              color="color1"
              :disabled="page >= paginationLength - 1"
              @click="goToNextPage()"
              class=""
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </template>
            <span>Next page</span>
          </v-tooltip>

        </div>
      </v-layout>


      <div style="overflow: auto; flex: 1; position: relative;">
          
        <!-- STICKY TABLE HEADER -->
        <div style="position: sticky; top: 0; z-index: 3;">
          <table class="final-table lines-r">
            <colgroup ref="colgroup1">
              <col width="400px">
              <col v-for="i in 7" :key="i" width="200px">
            </colgroup>
            <tr>
              <th class="sticky" style="white-space: nowrap;">
                Items
                <div class="handle" @mousedown="startColDrag(0, $event)"></div>
              </th>
              <th>
                Quantity
                <div class="handle" @mousedown="startColDrag(1, $event)"></div>
              </th>
              <th>
                Cost per unit
                <div class="handle" @mousedown="startColDrag(2, $event)"></div>
              </th>
              <th>
                Total cost
                <div class="handle" @mousedown="startColDrag(3, $event)"></div>
              </th>
              <th>
                Supplier
                <div class="handle" @mousedown="startColDrag(4, $event)"></div>
              </th>
              <th>
                Batch Number
                <div class="handle" @mousedown="startColDrag(5, $event)"></div>
              </th>
              <th>
                Expiry date
                <div class="handle" @mousedown="startColDrag(6, $event)"></div>
              </th>
              <th>
                VAT
                <div class="handle" @mousedown="startColDrag(7, $event)"></div>
              </th>
            </tr>
            <tr>
              <td class="sticky">
                <v-text-field
                v-model="searchText"
                placeholder="Search"
                hide-details
                class="crx-box-input"
                clearable
                solo></v-text-field>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>
        <!-- STICKY TABLE HEADER -->
          
        <table class="final-table lines-r hover">
          <colgroup ref="colgroup2">
            <col width="400px">
            <col v-for="i in 7" :key="i" width="200px">
          </colgroup>
          <delivery-row
          v-for="item in paginatedArray" 
          :vmode="0"
          :key="item.tempID"
          :lastVisited="null"
          :item="item"
          :selected="selected"
          :searchText="searchText"
          :currency="formData.currency"
          @checkRow="checkRow(item)"
          @click.native="clickRow(item)"
          ></delivery-row>
        </table>

        <!-- no item card (place this outside the scrolling div) -->
        <div v-if="(searchText || '').length > 0 && searchMatches.length === 0"
        class="ma-2 pa-2">
          No items match your search "<span class="font-weight-bold">{{ searchText }}</span>"
        </div>
        <div v-else-if="items.length < 1"
        class="ma-2 pa-2">
          No items
        </div>
        <!-- no item card -->

      </div>

      <!-- PAGINATION -->
      <c-pagination-client
      :page="page"
      :paginationLength="paginationLength"
      :paginatedArray="paginatedArray"
      :rowsPerPage.sync="rowsPerPage"
      @updatePageNumber="updatePageNumber"
      @goToFirstPage="goToFirstPage"
      @goToPreviousPage="goToPreviousPage"
      @goToNextPage="goToNextPage"
      @goToLastPage="goToLastPage">
      </c-pagination-client>
      <!-- PAGINATION -->

    </v-card>
    <!-- !MAIN -->

    <!-- DIALOGS -->
    <c-select-inv-def-dialog ref="selectItemDialog">
    </c-select-inv-def-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import ListController from '@/mixins/ListController'
import DragTableHeaders from '@/mixins/DragTableHeaders'
import DeliveryRow from './components/DeliveryInProcessRow'

export default {
  props: ['id'],
  mixins: [ListController, DragTableHeaders],
  components: {
    DeliveryRow
  },
  data () {
    return {
      saving: false,
      completing: false,
      lastSave: {
        rows: []
      },
      filters: {
        rowsPerPage: 5,
      },
      rowsPerPage: 5,
      isLoading: false,
      formData: {
        currency: undefined,
      },
    }
  },
  computed: {
    isDirty () {
      return !_.isEqual(this.lastSave, this.merged)
    },
    merged () {
      var merged = {
        rows: JSON.parse(JSON.stringify(this.items)),
      }
      return merged
    },
  },
  methods: {
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      }
    },
    addItem () {
      this.$refs.selectItemDialog.open()
        .then((selectedItem) => {
          this.items.push({
            definition: selectedItem,
            id: null,
            inventory_item_id: selectedItem.id,
            id_name: selectedItem.name,
            supplier_id: null,
            quantity: 0,
            expiry_date: null,
            batch_number: '',
            cost_per_unit: 0,
            vat: 0
          })
        })
        .catch(() => {
          // console.log('rejected')
        })
    },
    onDelete () {
      var selectedRows = this.getSelectedRows()
      var idArray = selectedRows.reduce((a, i) => {
        a.push(i.tempID)
        return a
      }, [])
      var title = 'Delete ' + idArray.length + ' row' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'color1' }).then((confirm) => {
        if (confirm) {
          for (var i = this.items.length - 1; i >= 0; --i) {
            if (idArray.includes(this.items[i].tempID)) {
              this.items.splice(i, 1)
            }
          }
          this.onSuccessfullDelete()
        }
      })
    },
    search (items) {
      if ((this.searchText || '').length > 0) {
        var keywords = (this.searchText || '').toLowerCase().split(' ')
        items = items.filter(item => {
          return keywords.every(keyword => {
            return (item.id_name.toLowerCase()).indexOf(keyword) > -1
          })
        })
      }
      return items
    },
    reload () {
      axios.all([
        this.$axios.get('/delivery-items/' + this.id),
      ])
      .then(axios.spread((deliveryItems) => {
        this.items = deliveryItems.data
        this.$nextTick(() => {
          this.lastSave.rows = JSON.parse(JSON.stringify(this.items))
        })
      }))
      .catch(error => this.$root.$errorSnackbar(error))
    },
    save () {
      this.saveAxios()
      .then(() => {
        this.reload()
      })
      .catch(error => this.$root.$errorSnackbar(error))
    },
    saveAxios () {
      return new Promise((resolve, reject) => {
        var prunedRows = this.items.map(item => {
          return {
            id: item.id,
            delivery_id: item.delivery_id,
            inventory_item_id: item.inventory_item_id,
            expiry_date: item.expiry_date,
            ordering: item.ordering,
            tempID: item.tempID,
            quantity: item.quantity,
            batch_number: item.batch_number,
            supplier_id: item.supplier_id,
            cost_per_unit: item.cost_per_unit,
            vat: item.vat,
            archive_id: item.archive_id,
          }
        })
        let data = {
          rows: JSON.parse(JSON.stringify(prunedRows))
        }
        this.saving = true
        this.$axios.patch('deliveries/delivery/' + this.id,
          data,
          {headers: {'Content-Type': 'application/json'}})
          .then(response => {
            resolve()
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            setTimeout(() => {
            this.saving = false
            }, 200)
          })
      })
    },
    completeDeliveryClicked () {
      this.$root.$confirm('Complete Delivery?', 'And add these items to inventory', { color: 'green' })
        .then((confirm) => {
          if (confirm) {
            this.completeDelivery()
          }
        })
    },
    completeDelivery () {
      this.completing = true
      this.saveAxios()
        .then(res => {
          return this.completeDeliveryAxios()
        })
        .catch(e => {
          console.log(e)
        })
        .then(() => {
          this.completing = false
        })
    },
    completeDeliveryAxios () {
      return new Promise((resolve, reject) => {
        this.$axios.post('deliveries/complete',
          {id: this.id},
          {headers: {'Content-Type': 'application/json'}})
          .then(response => {
            // return this.awaitRefetch()
          })
          .then(() => {
            this.$emit('onComplete')
            resolve()
          })
          .catch(error => {
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    },
    beforeRouteLeaveFaker (to, from, next) {
      if (this.isDirty) {
        this.$root.$confirm('Leave page?', 'You have unsaved changes. Leave page and undo changes?', { color: 'blue-grey' })
          .then((confirm) => {
            if (confirm) {
              next()
            } else {
              next(false)
            }
          })
      } else {
        next()
      }
    }
  },
  watch: {
    id (nv) {
      this.reload()
    }
  },
  created () {
    // console.log(Object.values(this.$store.state.db.currencies.items).filter(item => item.symbol === 'HRK'))
    this.formData.currency = 47 // EUR
    this.reload()
  },
  mounted () {
    this.colGroupRefs.push(this.$refs.colgroup1, this.$refs.colgroup2)
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('mouseup', this.mouseUp)
  }
}
</script>
